export default "__VITE_ASSET__BqEBhcUm__"